import type { PilotQuestionInstance } from '../../features/pilotMath/types';

type Props = { question: PilotQuestionInstance };

function splitOperation(prompt: string) {
  const match = prompt.match(/^(\d+)\s*([+−-])\s*(\d+)$/);
  if (!match) return null;
  return { a: match[1], op: match[2], b: match[3] };
}

export function MathQuestion({ question }: Props) {
  const operation = splitOperation(question.prompt);
  if (question.presentation === 'vertical' && operation) {
    return (
      <div className="math-vertical" aria-label={question.prompt}>
        <div>{operation.a}</div>
        <div><span>{operation.op}</span>{operation.b}</div>
        <div className="math-vertical__line" />
      </div>
    );
  }

  return (
    <div className={question.presentation === 'concept' ? 'math-concept' : 'math-horizontal'}>
      {question.supportingText && <p className="math-support">{question.supportingText}</p>}
      <strong>{question.prompt}</strong>
    </div>
  );
}
